<template>
  <div class="game-select" @click="toggleGameContainer">
    <div>
      <p class="game-label">SELECT GAME</p>
      <p class="game-name">{{ gameName }}</p>
    </div>
    <div>
      <img
        class="game-dropdown"
        :class="{ 'drop-up': showGameContainer }"
        src="@/assets/images/navbar/dropdown-icon.png"
        alt="drop down"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import { GAME_KEYS } from "@/store/game/game.constants"

export default {
  computed: {
    ...mapGetters("User", ["currentActiveGame"]),
    ...mapGetters("Util", ["showGameContainer"]),
    ...mapGetters("Game", [
      "gameNameByKey",
    ]),
    gameName () {
      let gameKey
      if (!this.currentActiveGame) {
        const gameParam = this.$route.params.game
        if (gameParam) {
          gameKey = gameParam
        } else {
          gameKey = GAME_KEYS.LEAGUE_OF_LEGENDS
        }
      } else {
        gameKey = this.currentActiveGame
      }
      return this.gameNameByKey(gameKey)
    },
  },
  methods: {
    ...mapActions("Util", ["toggleGameContainer"]),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.game-select {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.05),
      rgba(255, 255, 255, 0.05)
    ),
    #141417;
  height: 100%;
  width: 250px;
  padding: 0 1.5rem;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  @include desktop-down {
    height: 8rem;
    width: 100%;
    padding: 0 4rem;
  }
  .game-label {
    font-family: $font-display;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 110%;
    color: #ffffff;
    opacity: 0.5;
    margin-bottom: 0;
    @include desktop-down {
      font-size: 1.5rem;
    }
  }
  .game-name {
    text-transform: uppercase;
    font-family: $font-display;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 110%;
    color: #ffffff;
    @include desktop-down {
      font-size: 1.9rem;
    }
  }
  .game-dropdown {
    transition: transform 0.2s;
    vertical-align: unset;
  }
  .drop-up {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/game/GameSelect.vue